document.addEventListener('DOMContentLoaded', () => {
  const imageGallery = new Swiper('.image-gallery', {
    loopAdditionalSlides: 2,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 16,
        centeredSlides: true,
        initialSlide: 1,
      },
      481: {
        initialSlide: 1,
      },
      751: {
        spaceBetween: 16,
        initialSlide: 0,
        centeredSlides: false,
        centerInsufficientSlides: false,
        width: 312,
        watchOverflow: true
      }
    }
  });


  imageGallery.on('slideNextTransitionEnd', function (e) {
    toggleSlideNextFunctionality(e);
  });
  imageGallery.on('slidePrevTransitionEnd', function (e) {
    toggleSlideNextFunctionality(e);
  });

  const toggleSlideNextFunctionality = (e) => {
    const lastSlide = imageGallery.slides[imageGallery.slides.length - 1];
    const swiperRect = imageGallery.el.getBoundingClientRect();
    const lastSlideRect = lastSlide.getBoundingClientRect();
    const isFullyVisible = lastSlideRect.right <= swiperRect.right;

    if (isFullyVisible)  {
      imageGallery.allowSlideNext = false;
    }else {
      imageGallery.allowSlideNext = true;
    }

    console_log(e, isFullyVisible);
  }
       
});

